import { useContext, useRef, useEffect } from "react";
import { GraphContext } from "../contexts/ContextWrapper";
import { getProfilePhoto, getProfileData } from "../helpers/GetFromGraph";
import { GraphUser } from "../interfaces/GraphUser";
import { IsVerbose } from '../helpers/Console';

export const useGraphFetch = () => {
    const { graphContext, setGraphContext } = useContext(GraphContext);
    const abortControllerRef = useRef<AbortController | null>(null);
    
    // Handle cleanup on unmount
    useEffect(() => {
        // Create a local variable to prevent stale reference in cleanup
        const currentAbortController = abortControllerRef.current;
        
        return () => {
            if (currentAbortController) {
                IsVerbose() && console.log('GraphFetch hook unmounting, aborting pending operations');
                currentAbortController.abort();
            }
        };
    }, []);

    const FetchFromGraph = async (accessToken: string): Promise<void> => {
        // Create new AbortController for this operation
        if (abortControllerRef.current) {
            abortControllerRef.current.abort(); // Cancel any previous request
        }
        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;
       
        let myUserDetails: GraphUser
        let myUserPhoto: string
        
        try {
            // Check if aborted before starting fetch
            if (signal.aborted) {
                IsVerbose() && console.log('GraphFetch aborted: component unmounted');
                return;
            }

            [myUserDetails, myUserPhoto] = await Promise.all([
                getProfileData(accessToken),
                getProfilePhoto(accessToken),
            ]);
            
            // Check if aborted before setting context
            if (signal.aborted) {
                IsVerbose() && console.log('GraphFetch aborted after fetch: component unmounted');
                return;
            }

            // Only update context if not aborted
            if (!signal.aborted) {
                setGraphContext({
                    ...graphContext,
                    userDetails: myUserDetails,
                    userPhoto: myUserPhoto,
                });
            }
            
            return;
        } catch (error) {
            console.error('Error in GraphFetch:', error);
            if (!signal.aborted) {
                // Handle error as needed
            }
            throw error;
        }
    }

    return { FetchFromGraph }
}